import { Collapsible } from "@base-ui/react/collapsible";
import type { CSSProperties, ReactNode } from "react";

/**
 * A button that shows and hides what follows it, on Base UI's Collapsible (aria-expanded and
 * aria-controls are wired). Use it when the button and the content sit together; uncontrolled with
 * `defaultOpen`, or controlled with `open` and `onOpenChange`.
 */
export interface DisclosureProps {
  trigger: ReactNode;
  children: ReactNode;
  open?: boolean;
  defaultOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
  className?: string;
  triggerClassName?: string;
  triggerStyle?: CSSProperties;
  panelClassName?: string;
}

export function Disclosure({ trigger, children, open, defaultOpen, onOpenChange, className, triggerClassName, triggerStyle, panelClassName }: DisclosureProps) {
  return (
    <Collapsible.Root open={open} defaultOpen={defaultOpen} onOpenChange={onOpenChange ? (o) => onOpenChange(o) : undefined} className={className}>
      <Collapsible.Trigger className={triggerClassName} style={triggerStyle}>{trigger}</Collapsible.Trigger>
      <Collapsible.Panel className={panelClassName}>{children}</Collapsible.Panel>
    </Collapsible.Root>
  );
}
